import React from "react";

import playStoreImg from "../../src/assets/downloadapp/play.webp";
import appStoreImg from "../../src/assets/downloadapp/app.webp";

import mobileFront from "../../src/assets/downloadapp/mobile.webp";

export default function DownloadAppSection() {
  return (
    <section className="w-full overflow-hidden bg-[#f8f3f4] py-20">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-16 px-6 lg:flex-row lg:px-12">
        
        {/* Left Content */}
        <div className="max-w-2xl">
          <h2 className="text-5xl font-extrabold leading-tight text-[#1f1d4d] md:text-7xl">
            Download the app
          </h2>

          <p className="mt-8 text-2xl text-[#1f1d4d] md:text-4xl">
            Click, sit back, and enjoy.
          </p>

          {/* Store Buttons */}
          <div className="mt-10 flex flex-wrap items-center gap-5">
            <a href="/">
              <img
                src={playStoreImg}
                alt="Google Play"
                className="h-[62px] w-auto transition duration-300 hover:scale-105"
              />
            </a>

            <a href="/">
              <img
                src={appStoreImg}
                alt="App Store"
                className="h-[62px] w-auto transition duration-300 hover:scale-105"
              />
            </a>
          </div>
        </div>

        {/* Right Mobile Mockups */}
        <div className="relative flex items-end justify-center">
          

          {/* Front Mobile */}
          <img
            src={mobileFront}
            alt="mobile"
            className="relative z-10 w-[280px] md:w-[360px]"
          />
        </div>
      </div>
    </section>
  );
}